import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { TranslateService } from '@ngx-translate/core';
declare var $:any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  isShowPic: boolean = false;
  isDefaultImage: boolean = true;
  isEditPic: boolean = false;
  patientpersonalinfo: any;
  imageChangedEvent: any;
  croppedImage: any;
  path: any;
  ModalAvatar: any;
  isLargeScreen: boolean;
  title: string = "Breeze Check-in";
  defaultLanguage: any = 'en';
  isAppointmentDeatilComponent: boolean = false;
  showlanguageDropDown: boolean = true;
  PracticeName: any;
  PatientLastName: any;
  margintop: string = '19px';
  isRtl: boolean = false;
  constructor(private renderer: Renderer2,private translate: TranslateService, private _phrutilService: PhrutillsService, private spinner: NgxSpinnerService, private UpdateinfoService: UpdateinfoService) {
    
    let iphone = !navigator.platform && /iPhone/.test(navigator.platform);
    if(!iphone)
    { 
      let safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if(!safari)
      {
        //remove safari class when the device is not iphone and the browser is not safari
        $("body").removeClass("br-safari");
      }
    }

    //for android add the br-android class
    var userAgent = navigator.userAgent || navigator.vendor ;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent) || /android/i.test(userAgent)) {

      $("body").addClass("br-android");
        
    }

    this.translate.setDefaultLang('en');
    //console.log("nav bar");
  
  }
  selectlanguage(event: any) {
   // console.log("lang " + event.target.value);
    this.translate.use(event.target.value)
    localStorage.setItem('language', event.target.value);
    this.defaultLanguage = event.target.value;
    this._phrutilService.setPatientLanguage(this.defaultLanguage);
   this.setLanguageDirection(this.defaultLanguage);
  }

  ngOnInit(): void {
    //this.defaultLanguage = 'en';
    this._phrutilService.language$.subscribe(language => {
      this.defaultLanguage = language;
      this.setLanguageDirection(this.defaultLanguage);
     // console.log("dafault " + this.defaultLanguage);
    });
    this._phrutilService.title$.subscribe(title => {
      this.title = title;
      console.log(this.title);
      this.checkComponent();
    });
    let lang = localStorage.getItem('language');
    if (lang) {
      //console.log("lang navbar " + lang);
      this.defaultLanguage = lang;
      this.translate.use(lang);
      this.setLanguageDirection(this.defaultLanguage);
    } else {
      // console.log("no lang navbar");
      this.defaultLanguage = 'en';
      this.translate.use(this.defaultLanguage);
      this.setLanguageDirection(this.defaultLanguage);
    }
    this._phrutilService.setPatientLanguage(this.defaultLanguage);
    this.defaultImage = 'assets/images/userprof.jpg';
    this.ModalAvatar='assets/images/profileAvatar.svg';
    if (this.UpdateinfoService.subsIsShowProfilePic == undefined) {
      this.UpdateinfoService.subsIsShowProfilePic = this.UpdateinfoService.
      invokeIsShowPorfilePic.subscribe(() => {
        
        this.IshowProfilepic();
        this.getPatientProfilepath();
      });
    }
    if (this.UpdateinfoService.subsIsEditProfilePic == undefined) {
      this.UpdateinfoService.subsIsEditProfilePic = this.UpdateinfoService.
      invokeIsEditProfilePic.subscribe(() => {
        
        this.IsEditProfilePic();
      });
    }
    if(localStorage.getItem('PersonalInfo') && localStorage.getItem('PersonalInfo')!=''){
      this.IshowProfilepic();
      this.getPatientProfilepath();
    }
    this.IshowProfilepic();
    this.onResize(null);
 
    this._phrutilService.lastName.subscribe(value => {
      this.PatientLastName = value;
    });
    this._phrutilService.pracName.subscribe(value => {
      this.PracticeName = value;
    });
   
    const savedDirection = localStorage.getItem('languageDirection');
    if (savedDirection === 'rtl') {
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
    }
   // console.log(this.PracticeName);
    //console.log(this.PatientLastName);
  }

  // Check if the selected language is RTL (e.g., Urdu)
  setLanguageDirection(languageCode: any) {
    console.log(languageCode);
    if (languageCode === 'ur') {
      console.log("urdu RTL");
      this.isRtl = true;
      document.documentElement.setAttribute('dir', 'rtl');
      localStorage.setItem('languageDirection', 'rtl'); 
    } else {
      this.isRtl = false;
      document.documentElement.setAttribute('dir', 'ltr');
      localStorage.setItem('languageDirection', 'ltr'); 
  }
}



  Verifypatient: boolean = false;
  otherComponent: boolean = true;
  checkComponent() {
    if (this.title == "referral") {
      const pname = localStorage.getItem("prName");
      this.PracticeName = pname;
    }
    if (this.title === "HPI" || this.title === "Symptom Checker" || this.title === "Intake Forms"
      || this.title === "Comprobador de síntomas" || this.title === "Formularios de admisión") {
      this.showlanguageDropDown = false;
    } else {
      this.showlanguageDropDown = true;
    }
    if (this.title == "Appointment Detail") {
      this.isAppointmentDeatilComponent = true;
      this.Verifypatient = false;
      this.otherComponent = false;
    } else {
      this.isAppointmentDeatilComponent = false;
    }
    if (this.title == "Verify Patient" || this.title =="referral") {
      this.Verifypatient = true;
      this.isAppointmentDeatilComponent = false;
      this.otherComponent = false;
    } else {
      this.Verifypatient = false;
    }

    if (this.title === "Financial Form" || this.title === "Consent Form" || this.title === "Insurance" || this.title === "Demographics" || this.title === "Medical History"
      || this.title === "Intake Forms" || this.title === "Symptom Checker" || this.title === "Thank You" || this.title ==="Gracias" || this.title === "HPI"
      || this.title === "Allergies"  || this.title === "Medications" || this.title === "Family History" || this.title === "Social History"
      || this.title === "Formulario de consentimiento" || this.title === "Historia social" || this.title === "Hospitalización pasada" || this.title === "Historial Quirúrgico Pasado" || this.title === "Medicamentos"
      || this.title === "Historial Familiar" || this.title === "Alergias" || this.title === "Seguro" || this.title === "Demografía"
      || this.title === "Formulario financiero" || this.title === "Comprobador de síntomas" || this.title === "Formularios de admisión" || this.title === "Detalles del saldo" || this.title === "Balance Details"
      || this.title === "Payment" || this.title === "Pago" || this.title === "Reason For Visit" || this.title === "Razón de la visita"
      || this.title === 'सहमति पत्र' || this.title === 'वित्तीय स्वरूप' || this.title === 'बीमा' || this.title === 'भुगतान' || this.title === 'शेष विवरण'
      || this.title === 'लक्षण जांचकर्ता' || this.title === 'सेवन प्रपत्र' || this.title === 'धन्यवाद' || this.title === 'जनसांख्यिकी' || this.title === 'यात्रा का कारण'
      || this.title === 'एलर्जी' || this.title === 'दवाइयाँ' || this.title === 'पारिवारिक इतिहास' || this.title === 'पिछला सर्जिकल इतिहास' || this.title === 'विगत अस्पताल में भर्ती' || this.title === 'सामाजिक इतिहास'
      || this.title === 'رضامندی کا فارم' || this.title === 'مالیاتی فارم' || this.title === 'انشورنس' || this.title === 'ادائیگی' || this.title === 'بیلنس کی تفصیلات'
      || this.title === 'علامات کی جانچ کرنے والا' || this.title === 'انٹیک فارمز' || this.title === 'شکریہ' || this.title === 'ڈیموگرافکس' || this.title === 'وزٹ کی وجہ' || this.title === 'الرجی'
      || this.title === 'خاندانی ہسٹری' || this.title === 'فارمیسی اور ادویات' || this.title === 'ماضی کی سرجیکل ہسٹری' || this.title === 'ماضی میں ہسپتال میں داخل ہونا' || this.title === 'سوشَل ہسٹری'
      || this.title === 'Breeze Check-in' || this.title === 'Patient Registration' || this.title === 'مریض کی رجسٹریشن' || this.title === 'Registro de pacientes'
      || this.title === 'Book an Appointment' || this.title === 'اپوائنٹمنٹ بک کریں' || this.title === 'अपॉइंटमेंट बुक करें' || this.title === 'Reserve una cita'
      || this.title === 'Pay Due Balance' || this.title === 'بقایا بیلنس ادا کریں' || this.title === 'बकाया राशि का भुगतान करें' || this.title === 'Pagar el saldo adeudado'
      || this.title === 'Check-in for Appointment' || this.title === 'اپوائنٹمنٹ کے لیے چیک ان کریں' || this.title === 'अपॉइंटमेंट के लिए चेक-इन करें' || this.title === 'Regístrese para una cita'
      || this.title === 'Saldo deudor' || this.title === 'शेष राशि' || this.title === 'بقایا بیلنس' || this.title === 'Balance Due') {
      this.otherComponent = true;
    } else {
    }
    console.log(this.title, this.Verifypatient)
    console.log(this.title, this.isAppointmentDeatilComponent)
    console.log(this.otherComponent)
  }



  getPatientProfilepath()
  {
    let info = localStorage.getItem('PersonalInfo');
    if(!info){
      return;
    }
    let photoAddress = localStorage.getItem('pictureAddress');

    photoAddress = this._phrutilService.decryptforServices(photoAddress);
   
    try {
      // Split the path into parts
      let parts = photoAddress.split('\\');
   
      let path = "assets\\";
      for (let i = 3; i < parts.length; i++) {
      
    
        if(i==parts.length-1)
          path = path + parts[i] ;
        else
          path = path + parts[i] + "\\";;

      
      }

      photoAddress = path;
      //console.log("photo address ", photoAddress);
     
    } catch (error) {
      console.log("error in photoimage line number 144 " + error);
      photoAddress = "";
    }
    if (photoAddress) {
      this.defaultImage = photoAddress;
     // this.defaultImage = "assets" + "\\" + this.path + "\\" + this.patientpersonalinfo.PRACTICE_CODE + "\\PATIENT PICTURE\\" + this.patientpersonalinfo.PICTURE_ADDRESS;
    }
    else {
      if (this.patientpersonalinfo.GENDER == "Male") {
        this.defaultImage = 'assets/images/man-avatar.png';
      }
      else if (this.patientpersonalinfo.GENDER == "Female") {
        this.defaultImage = 'assets/images/women-avatar.png';
      } else {
        this.defaultImage = 'assets/images/default.jpg';
      }
    }
    //console.log("default photo address ", this.defaultImage);
    this.patientpersonalinfo = this._phrutilService.decrypt(info);
   /* this.UpdateinfoService.GetPracticeDocumentsServer(this.patientpersonalinfo.PATIENT_ACCOUNT.toString(), this.patientpersonalinfo.PRACTICE_CODE.toString()).subscribe((res:any) => 
    {
      this.path = res.data;
      if (this.patientpersonalinfo.PICTURE_ADDRESS) {
        this.defaultImage="assets"+"\\" + this.path + "\\" + this.patientpersonalinfo.PRACTICE_CODE + "\\PATIENT PICTURE\\" + this.patientpersonalinfo.PICTURE_ADDRESS;
      }
      else{
        if(this.patientpersonalinfo.GENDER=="Male"){
          this.defaultImage='assets/images/man-avatar.png';
        }
        else if(this.patientpersonalinfo.GENDER=="Female"){
          this.defaultImage='assets/images/women-avatar.png';
        } else{
          this.defaultImage='assets/images/default.jpg';
        }    
      }
      
    },(error:any) =>
    {
      if(this.patientpersonalinfo.GENDER=="Male"){
        this.defaultImage='assets/images/man-avatar.png';
      }
      else if(this.patientpersonalinfo.GENDER=="Female"){
        this.defaultImage='assets/images/women-avatar.png';
      } else{
        this.defaultImage='assets/images/default.jpg';
      }  
    });*/
  }
  IshowProfilepic() {
    let alreadyCheckin = localStorage.getItem('alredycheckin');
    //console.log("already checkin ", alreadyCheckin);

    if (alreadyCheckin == 'true') {
      this.isShowPic = true;
    } else {
      //console.log("already checkin ");
      let info = localStorage.getItem('PersonalInfo');
      if (!info) {
        this.isShowPic = false;
        return;
      }
      this.patientpersonalinfo = this._phrutilService.decrypt(info);
      if (this.patientpersonalinfo.isShowpicture)
        this.isShowPic = true;
      else
        this.isShowPic = false;
    }
    
  }
  IsEditProfilePic() {
    let info = localStorage.getItem('PersonalInfo');
    if(!info){
      this.isEditPic = false;
      return;
    }
    this.patientpersonalinfo = this._phrutilService.decrypt(info);
    if (this.patientpersonalinfo.isEditProfilePic)
    this.isEditPic = true;
    else
      this.isEditPic = false;
    this.IshowProfilepic();
  }
  fileChangeEvent(event: any) {
    
    let info = localStorage.getItem('PersonalInfo');
    if(!info){
      return;
    }
    this.patientpersonalinfo = this._phrutilService.decrypt(info);
    
    var mimeType = event.target.files[0].type;
    var file = event.target.files[0].file;
    if (mimeType.match(/image\/*/) == null) {
      let text = "Only images are supported.";
      this.translate.get('Alerts.only_images_are_supported').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
     // this._phrutilService.showError("Error", "Only images are supported.");
      this.imageChangedEvent = undefined;
      return;
    }
    var filename = event.currentTarget.value.toLowerCase();
    let ext = this.getFileExtension(filename);
    if (ext != 'png' && ext != 'jpg' && ext != 'jpeg' && ext != 'gif') {
      let text = "File format is invalid!. Please select jpg, jpeg, png or gif file.";
      this.translate.get('Alerts.file_format_invalid').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      //this._phrutilService.showError("Error", "File format is invalid!. Please select jpg, jpeg, png or gif file.");
      event = "";
      this.imageChangedEvent = undefined;
      return;
    }
    
    this.imageChangedEvent = event.target.files[0];
    this.isDefaultImage = false;
    
    this.spinner.show();
    this.UpdateinfoService.uploadAtFolder(this.imageChangedEvent, "api/TalkCheckin/SaveProfilePicture", this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE).subscribe((res: any) => {
      
      this.spinner.hide();
      if (res.statusCode == 200) {
        res.data = res.data.replace(/\\\\/g, "\\");
        res.data = res.data.replace(/\\/g, "/"); 
        let serverIp = res.data.split('/');
        
        this.patientpersonalinfo.PICTURE_ADDRESS = serverIp[serverIp.length-1];
        let data = this._phrutilService.encrypt(this.patientpersonalinfo);
        localStorage.setItem('PersonalInfo', data);
        //this.getPatientProfilepath();
        this.showPreview(event);
        let text = "Profile picture has been updated";
        this.translate.get('Alerts.profile_picture_updated').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showSuccess(text);
        //this._phrutilService.showSuccess("Profile picture has been updated");
      }
    },
    (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translate.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      //this._phrutilService.showError("Service is not available, please try later.");
    })
    
  }
  //show local image 
  showPreview(event: Event) {
    let selectedFile = (event.target as HTMLInputElement).files?.item(0)

    if (selectedFile) {
      if (["image/jpeg", "image/png", "image/svg+xml","image/gif"].includes(selectedFile.type)) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);

        fileReader.addEventListener('load', (event) => {
          this.defaultImage = event.target?.result;
          //this.isImageSelected = true
        })
      }
    } else {
      //this.isImageSelected = false
    }
  }

  getFileExtension(fileName: any) {
    return fileName.toLowerCase().split('.').pop();
  }
  defaultImage: any;
  onImageError() {
    let info = localStorage.getItem('PersonalInfo');
    if(!info){
      return;
    }
    this.patientpersonalinfo = this._phrutilService.decrypt(info);
    if (this.patientpersonalinfo.GENDER == "Male") {
      this.defaultImage = 'assets/images/userprof.jpg';
    }
    else if (this.patientpersonalinfo.GENDER == "Female") {
      this.defaultImage = 'assets/images/women-avatar.png';
    } else {
      this.defaultImage = 'assets/images/userprof.jpg';
    }
    console.log("default photo address on error", this.defaultImage);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    this.isLargeScreen = window.innerWidth > 768;
    //console.log(this.isLargeScreen);
    const header = document.querySelector('header'); 

    if (header) {
      if (this.isLargeScreen) {
        this.renderer.addClass(header, 'justify-content-center');
      } else {
        this.renderer.removeClass(header, 'justify-content-center');
      }
    }
  }

  ngAfterViewInit() {
    setTimeout(()=> {
      const alreadyCheckin = localStorage.getItem('alredycheckin');
      //console.log("already checkin ", alreadyCheckin);
      if (alreadyCheckin == 'true') {
        this.isShowPic = true;
      }
    },1500)
   
  }
  
}
